<template>
	<form @submit.prevent="">
		<div class="form-row">
			<div class="col-12">
				<label for="note-name">عنوان یادداشت</label>
				<input type="text" id="note-name" placeholder="عنوان یادداشت" class="widget-input input-no-bg input-lg input-set-border w-100" v-model="note.title">

			</div>
			
			<div class="col-12" style="margin-top: 15px;margin-bottom: 15px;">
				<label for="note-category">پوشه یادداشت</label>
				<!-- <select v-model="note.category_id" class="form-control t-widget-select widget-select-lg select-set-border" id="note-category">
					<option v-for="category in categories" :key="category.id" :value="category.id">{{ category.title }}</option>
				</select> -->
				<div class="widget-select w-100 m-top folder-tags widget-select-lg">
					<v-select v-model="note.category_id" :clearable="false"  label="title"  :reduce="(option) => option.id" :options="categories">
					</v-select>
				</div>
			</div>
		</div>

		<div class="form-row text-center mt-4">
			<div class="col-12">
				<a href="" @click.prevent="saveChanges()" class="m-left min-w150 tgju-btn tgju-btn-lg tgju-btn-primary rename-note"><i class="uil uil-save"></i> ذخیره تغییرات</a>
			</div>
		</div>
	</form>
</template>

<script> 
	import vSelect from 'vue-select'
	Vue.component('v-select', vSelect);

	export default {
		name: 'NoteEdit',
		props: ['data'],
		components: {},
		data: function () {
			return {
				note: {
					title: '',
					category_id: null,
				},
				categories: []
			}
		},

		mounted() {
			this.$watch('data', function(newValue, oldValue) {
				if ( Object.keys(newValue).length ) {
					this.loadData();
				}
			}, {immediate: true});
		},

		methods: {
			loadData() {
				this.note = this.data.note;
				this.categories = this.data.categories;

				if ( !this.note.category_id ) {
					this.note.category_id = this.categories[0].id;
				}
			},

			saveChanges() {
				if(this.note.title && this.note.category_id) {
					this.$parent.emitData('editNote', {note: this.note}, true);
				}
			}
		},
	}
</script>